import { observer } from 'mobx-react-lite'
import React from 'react'

import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Stack from '@mui/material/Stack'
import { useTheme } from '@mui/material/styles'

import { ExpandLess, ExpandMore } from '@mxenabled/mx-icons'
import { Text } from '@mxenabled/mxui'

interface CollapseExpandListItemProps {
  isExpanded: boolean
  onClick: () => void
}

export const CollapseExpandListItem: React.FC<CollapseExpandListItemProps> = observer(
  ({ isExpanded, onClick }) => {
    const theme = useTheme()
    return (
      <ListItem>
        <ListItemButton onClick={onClick} sx={{ justifyContent: 'center' }}>
          <Stack
            sx={{ color: theme.palette.primary.main, flexDirection: 'row', alignItems: 'center' }}
          >
            <ListItemText>
              <Text bold={true} variant="body2">
                {isExpanded ? `View less` : `View more`}
              </Text>
            </ListItemText>
            <ListItemIcon sx={{ color: theme.palette.primary.main }}>
              {isExpanded ? (
                <ExpandLess />
              ) : (
                <ExpandMore
                  sx={{
                    transition: 'transform 0.3s ease-in-out',
                    transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                  }}
                />
              )}
            </ListItemIcon>
          </Stack>
        </ListItemButton>
      </ListItem>
    )
  },
)
